(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { observer.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---------- Accordions ---------- */
  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    accordion.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.nextElementSibling;
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });
  });

  /* ---------- "Jak dobrać rozmiar?" link: open + scroll to the size-guide accordion ---------- */
  document.querySelectorAll('[data-size-guide-link]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = (link.getAttribute('href') || '').replace('#', '');
      var target = targetId && document.getElementById(targetId);
      if (!target) return; // let the browser handle a plain anchor jump
      e.preventDefault();
      var trigger = target.querySelector('[data-accordion-trigger]');
      var panel = target.querySelector('[data-accordion-panel]');
      if (trigger && panel && trigger.getAttribute('aria-expanded') !== 'true') {
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Review sorting ---------- */
  document.querySelectorAll('[data-review-sort]').forEach(function (select) {
    var list = document.querySelector('[data-reviews-list]');
    if (!list) return;
    var originalOrder = Array.prototype.slice.call(list.children);
    select.addEventListener('change', function () {
      var items = Array.prototype.slice.call(list.children);
      if (select.value === 'newest') {
        originalOrder.forEach(function (el) { list.appendChild(el); });
      } else {
        items.sort(function (a, b) {
          var ra = parseInt(a.getAttribute('data-rating'), 10) || 0;
          var rb = parseInt(b.getAttribute('data-rating'), 10) || 0;
          return select.value === 'highest' ? rb - ra : ra - rb;
        });
        items.forEach(function (el) { list.appendChild(el); });
      }
    });
  });

  /* ---------- Review form toggle ---------- */
  document.querySelectorAll('[data-toggle-review-form]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.querySelector('[data-review-form]');
      if (form) {
        form.hidden = !form.hidden;
        if (!form.hidden) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  /* ---------- Quantity steppers (generic) ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrapper = (minus || plus).closest('.qty-selector');
    var input = wrapper && wrapper.querySelector('[data-qty-input]');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    var maxAttr = input.getAttribute('max');
    var max = (maxAttr !== null && maxAttr !== '') ? parseInt(maxAttr, 10) : null;
    value = plus ? value + 1 : Math.max(min, value - 1);
    if (max !== null && !isNaN(max)) value = Math.min(max, value);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Quantity inputs: clamp direct typing to [min, max] too, not just the +/- buttons ---------- */
  document.querySelectorAll('[data-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var min = parseInt(input.min, 10);
      if (isNaN(min)) min = 0;
      var maxAttr = input.getAttribute('max');
      var max = (maxAttr !== null && maxAttr !== '') ? parseInt(maxAttr, 10) : null;
      var value = parseInt(input.value, 10);
      if (isNaN(value)) value = min;
      value = Math.max(min, value);
      if (max !== null && !isNaN(max) && value > max) {
        value = max;
      }
      input.value = value;
    });
  });

  /* ---------- Gallery thumbnails (click + touch swipe) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImageWrap = gallery.querySelector('[data-main-image]');
    var mainImg = mainImageWrap && mainImageWrap.querySelector('img');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    if (!mainImg || !thumbs.length) return;

    function activeIndex() {
      var idx = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      return idx === -1 ? 0 : idx;
    }

    function selectThumb(thumb) {
      if (!thumb) return;
      // The hero image renders with a `srcset` covering the ORIGINAL photo's widths. Once set,
      // srcset takes priority over `src` for the browser's own image selection, so just swapping
      // `src` here was silently ignored — the thumbnail highlight moved but the displayed photo
      // never did. Clearing srcset/sizes first forces the browser to actually use our new src.
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = thumb.getAttribute('data-src');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (thumb.scrollIntoView) thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { selectThumb(thumb); });
    });

    // Swipe the main product photo left/right to move through the gallery (mobile).
    // touch-action: pan-y (see CSS) keeps native vertical scrolling smooth and responsive
    // (with its normal momentum) everywhere on this image; we only step in and claim the
    // gesture with preventDefault once a drag clearly reads as horizontal.
    if (thumbs.length > 1 && mainImageWrap) {
      var touchStartX = 0;
      var touchStartY = 0;
      var tracking = false;
      var horizontalIntent = false;

      function resolveSwipe(endX, endY) {
        var dx = endX - touchStartX;
        var dy = endY - touchStartY;
        if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) return;
        var current = activeIndex();
        var next = dx < 0
          ? Math.min(thumbs.length - 1, current + 1)
          : Math.max(0, current - 1);
        if (next !== current) selectThumb(thumbs[next]);
      }

      mainImageWrap.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        tracking = true;
        horizontalIntent = false;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      mainImageWrap.addEventListener('touchmove', function (e) {
        if (!tracking || !e.touches || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;
        if (!horizontalIntent && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
          horizontalIntent = true;
        }
        if (horizontalIntent && e.cancelable) e.preventDefault();
      }, { passive: false });

      mainImageWrap.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var touch = e.changedTouches && e.changedTouches[0];
        if (!touch) return;
        resolveSwipe(touch.clientX, touch.clientY);
      }, { passive: true });

      mainImageWrap.addEventListener('touchcancel', function () {
        tracking = false;
      }, { passive: true });
    }
  });

  /* ---------- Variant selection + purchase mode + Add to cart (hero / product form) ---------- */
  document.querySelectorAll('.hero-product__form').forEach(function (form) {
    var section = form.closest('.hero-product');
    var variantScript = section && section.querySelector('[data-hero-product-variants]');
    var variants = [];
    try { variants = variantScript ? JSON.parse(variantScript.textContent) : []; } catch (err) { variants = []; }

    var variantIdInput = form.querySelector('[data-variant-id]');
    var stockNote = form.querySelector('[data-stock-note]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addBtnText = form.querySelector('[data-add-to-cart-text]');
    var singlePriceEl = form.querySelector('[data-single-price]');
    var bundlePriceEl = form.querySelector('[data-bundle-price]');
    var bundleUnitPriceEl = form.querySelector('[data-bundle-unit-price]');
    var singlePicker = form.querySelector('[data-variant-picker-single]');
    var bundlePicker = form.querySelector('[data-variant-picker-bundle]');
    var purchaseOptionsEl = form.querySelector('[data-purchase-options]');
    // "Zestaw 2 szt." is no longer a separate product — it's this product's own color option
    // value (e.g. "Beżowy+Czarny") rendered as a data attribute on the purchase-options wrapper.
    var bundleComboColor = purchaseOptionsEl ? purchaseOptionsEl.getAttribute('data-bundle-combo-color') : null;
    var purchaseRadios = form.querySelectorAll('[data-purchase-type]');
    var qtyWrap = form.querySelector('[data-qty-wrap]');
    var bundleSizeGroup = form.querySelector('[data-bundle-size-group]');
    // Remember the variant id rendered server-side so add-to-cart never has nothing to submit.
    var fallbackVariantId = variantIdInput ? variantIdInput.value : (variants[0] && variants[0].id);

    function currentMode() {
      var checked = form.querySelector('[data-purchase-type]:checked');
      return checked ? checked.value : 'single';
    }

    function optionValuesMatch(optVal, selected) {
      if (optVal === selected) return true;
      // Tolerate whitespace/case differences between the picker's value and Shopify's stored option value,
      // without ever guessing a different product when the combination genuinely doesn't match.
      return typeof optVal === 'string' && typeof selected === 'string' &&
        optVal.trim().toLowerCase() === selected.trim().toLowerCase();
    }

    function variantHasOptionValue(v, val) {
      return optionValuesMatch(v.option1, val) || optionValuesMatch(v.option2, val) || optionValuesMatch(v.option3, val);
    }

    function variantForGroup(groupEl) {
      // No picker was rendered at all => the product has only one variant, so variants[0] is the real answer, not a guess.
      if (!groupEl) return variants[0] || null;
      var selections = [];
      groupEl.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input[data-option-selector]:checked');
        selections.push(checked ? checked.value : null);
      });
      if (!selections.length) return variants[0] || null;
      // A picker exists and the customer made a selection: find the exact matching variant.
      // If nothing matches, return null rather than silently substituting a different product.
      return variants.find(function (v) {
        return selections.every(function (val, i) {
          return val === null || optionValuesMatch(v['option' + (i + 1)], val);
        });
      }) || null;
    }

    function variantForPrefix(prefix) {
      var group = form.querySelector('[data-option-group="' + prefix + '"]');
      return variantForGroup(group);
    }

    function singleSelectedVariant() {
      return variantForPrefix('single');
    }

    function selectedBundleSize() {
      var checked = bundleSizeGroup && bundleSizeGroup.querySelector('[data-bundle-size-selector]:checked');
      return checked ? checked.value : null;
    }

    // "Zestaw 2 szt." is this SAME product's combined color value (e.g. "Beżowy+Czarny") — not a
    // separate Shopify product. We find the one variant that matches both that combo color and the
    // chosen size among this product's own variants.
    function bundleVariantForSize(sizeValue) {
      if (!sizeValue || !bundleComboColor) return null;
      return variants.find(function (v) {
        return variantHasOptionValue(v, bundleComboColor) && variantHasOptionValue(v, sizeValue);
      }) || null;
    }

    function selectedBundleVariant() {
      return bundleVariantForSize(selectedBundleSize());
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' zł';
    }

    function updateUI() {
      try {
        var mode = currentMode();

        form.querySelectorAll('.purchase-option').forEach(function (label) {
          var input = label.querySelector('[data-purchase-type]');
          label.classList.toggle('is-active', input && input.checked);
        });

        if (singlePicker) singlePicker.hidden = mode !== 'single';
        if (bundlePicker) bundlePicker.hidden = mode !== 'bundle';
        if (qtyWrap) qtyWrap.hidden = mode === 'bundle';

        var single = singleSelectedVariant();
        if (single && variantIdInput) variantIdInput.value = single.id;
        if (single && singlePriceEl) singlePriceEl.textContent = formatMoney(single.price);

        var bundleVariant = selectedBundleVariant();
        if (bundleVariant) {
          if (bundlePriceEl) bundlePriceEl.textContent = formatMoney(bundleVariant.price);
          if (bundleUnitPriceEl) bundleUnitPriceEl.textContent = formatMoney(Math.round(bundleVariant.price / 2)) + ' / szt.';
        }

        // Fail open only when we have no variant data at all to work with (e.g. a JSON parse error) —
        // that's the one case where blocking the button would be wrong. A real, matched variant that's
        // out of stock, or a selection that doesn't match any variant, must NOT be treated as available:
        // silently falling back would add the wrong product to the cart instead of the one the customer picked.
        var noVariantData = variants.length === 0;

        if (mode === 'single') {
          var available = single ? single.available !== false : noVariantData;
          if (addBtn) addBtn.disabled = !available;
          if (stockNote) {
            stockNote.textContent = available
              ? 'Dostępny — szybka wysyłka'
              : (single ? 'Chwilowo niedostępny' : 'Wybierz wariant produktu');
          }
        } else {
          var bundleAvailable = bundleVariant ? bundleVariant.available !== false : false;
          if (addBtn) addBtn.disabled = !bundleAvailable;
          if (stockNote) {
            stockNote.textContent = bundleAvailable
              ? 'Dostępny — szybka wysyłka'
              : (bundleVariant ? 'Chwilowo niedostępny' : 'Wybierz wariant produktu');
          }
        }

        if (addBtnText) {
          addBtnText.textContent = addBtn && addBtn.disabled ? 'Wyprzedane' : 'Dodaj do koszyka';
        }
      } catch (err) {
        // Never let a UI-refresh error leave the add-to-cart button stuck disabled.
        console.error('Chestivo: updateUI failed, leaving add-to-cart enabled.', err);
        if (addBtn) addBtn.disabled = false;
      }
    }

    // Register submit handling first so add-to-cart works even if a later
    // listener setup throws (e.g. an unexpected DOM shape on this page).
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn) addBtn.disabled = true;

      try {
        var mode = currentMode();
        var qty = Math.max(1, parseInt((form.querySelector('[data-qty-input]') || {}).value, 10) || 1);
        var items = [];

        // Only fall back to the page-load default variant when there's truly no variant data to match
        // against (e.g. a JSON parse error). If real data exists but the selection doesn't match any
        // variant, never guess — that would add a different product than the one the customer picked.
        var noVariantData = variants.length === 0;

        if (mode === 'single') {
          var single = singleSelectedVariant();
          var singleId = single ? single.id : (noVariantData ? ((variantIdInput && variantIdInput.value) || fallbackVariantId) : null);
          if (singleId) items.push({ id: singleId, quantity: qty });
        } else {
          // The bundle adds a single line item: the dedicated bundle product's variant for the chosen
          // size. Its fixed price (and its 1x+1x component inventory) live on that product itself, so
          // no cart-side discount or line grouping is needed here anymore.
          var bundleVariant = selectedBundleVariant();
          if (bundleVariant) items.push({ id: bundleVariant.id, quantity: 1 });
        }

        if (!items.length) {
          showNotification('Wybierz wariant produktu.', true);
          if (addBtn) addBtn.disabled = false;
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              showNotification(data.description || 'Nie udało się dodać produktu do koszyka.', true);
            } else {
              updateCartCount();
              showCartConfirmModal(mode === 'bundle' ? 'Zestaw 2 szt. trafił do koszyka.' : 'Produkt trafił do koszyka.');
            }
          })
          .catch(function () {
            showNotification('Wystąpił błąd. Spróbuj ponownie.', true);
          })
          .finally(function () {
            if (addBtn) addBtn.disabled = false;
          });
      } catch (err) {
        console.error('Chestivo: add-to-cart submit failed.', err);
        showNotification('Wystąpił błąd. Spróbuj ponownie.', true);
        if (addBtn) addBtn.disabled = false;
      }
    });

    try {
      purchaseRadios.forEach(function (radio) { radio.addEventListener('change', updateUI); });
      if (bundleSizeGroup) {
        bundleSizeGroup.querySelectorAll('[data-bundle-size-selector]').forEach(function (input) {
          input.addEventListener('change', updateUI);
        });
      }
      form.querySelectorAll('[data-option-selector]').forEach(function (input) {
        input.addEventListener('change', updateUI);
      });
      updateUI();
    } catch (err) {
      console.error('Chestivo: variant picker init failed, add-to-cart still enabled.', err);
      if (addBtn) addBtn.disabled = false;
    }

    // When the customer returns to this page via the browser's Back/Forward button, some browsers
    // silently restore which radio is checked (bundle vs single, or a color/size choice) without firing
    // a "change" event — the native ":checked" CSS highlight then jumps to the restored option while our
    // own "is-active" class (and disabled/stock state) stays stuck on whatever was shown before leaving,
    // so two purchase options can appear selected at once until something is clicked. Re-running updateUI()
    // whenever the page becomes visible again (bfcache restore or a fresh restore-from-history load) keeps
    // the highlighted option and the actually-checked radio in sync.
    window.addEventListener('pageshow', updateUI);
  });

  /* ---------- Post add-to-cart confirmation modal ---------- */
  function showCartConfirmModal(message) {
    var modal = document.getElementById('cart-confirm-modal');
    if (!modal) return;
    var subtitle = modal.querySelector('[data-modal-subtitle]');
    if (subtitle) subtitle.textContent = message;
    modal.hidden = false;
    document.body.classList.add('modal-open');
  }
  function hideCartConfirmModal() {
    var modal = document.getElementById('cart-confirm-modal');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('modal-open');
  }
  document.querySelectorAll('[data-modal-dismiss]').forEach(function (el) {
    el.addEventListener('click', hideCartConfirmModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideCartConfirmModal();
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  function showNotification(message, isError) {
    var el = document.getElementById('cart-notification');
    if (!el) return;
    var msgEl = el.querySelector('.cart-notification__msg');
    if (msgEl) msgEl.textContent = message;
    el.classList.toggle('cart-notification--error', !!isError);
    el.hidden = false;
    clearTimeout(el._timeout);
    el._timeout = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ---------- Cart page: quantity + remove ---------- */
  // Lines are identified by their position in cart.items (Shopify's "line", 1-based). Shopify's
  // line-item "key" looked like a stabler identifier, but it is NOT stable across unrelated cart
  // changes — removing one line can change the key Shopify reports for another, which silently
  // broke "remove the whole set" (only one of its two lines was ever actually removed). Line
  // numbers are stable as long as removals within one action go from the highest number to the
  // lowest, since removing a line only shifts the numbering of lines that come AFTER it.
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    cartForm.querySelectorAll('[data-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = input.getAttribute('data-line');
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        changeCartLine(line, quantity).then(function () { window.location.reload(); });
      });
    });

    cartForm.querySelectorAll('[data-remove-item]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeCartLine(btn.getAttribute('data-line'), 0).then(function () { window.location.reload(); });
      });
    });

    cartForm.querySelectorAll('[data-remove-bundle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var lines = (btn.getAttribute('data-remove-bundle') || '')
          .split(',')
          .filter(Boolean)
          .map(function (n) { return parseInt(n, 10); })
          .sort(function (a, b) { return b - a; }); // highest line number first
        lines.reduce(function (chain, line) {
          return chain.then(function () { return changeCartLine(line, 0); });
        }, Promise.resolve()).then(function () { window.location.reload(); });
      });
    });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).catch(function () { window.location.reload(); });
  }
})();
